import React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

export type NodeEditorState = 'ready' | 'configured' | 'wontRun' | 'caution';

const SEVERITY: Record<NodeEditorState, 'success' | 'info' | 'warning'> = {
    ready: 'success',
    configured: 'info',
    wontRun: 'warning',
    caution: 'warning'
};

export interface NodeEditorLayoutProps {
    children?: React.ReactNode;
    summary: React.ReactNode;
    state?: NodeEditorState;
    /** Grow to the dialog's height, so one field can take the rest (Send Email's preview, enlarged). */
    fill?: boolean;
}

/**
 * An editor's fields plus the one summary alert. `wontRun`: the config can never fire; `caution`: it runs, but the
 * setup needs saying. Config status goes only here; guidance for a separate control sits beside that control.
 */
const NodeEditorLayout = ({children, summary, state = 'configured', fill}: NodeEditorLayoutProps) => (
    <Stack gap={2.5} sx={fill ? {flex: '1 0 auto'} : undefined}>
        {children}

        <Alert severity={SEVERITY[state]} sx={{flexShrink: 0, alignItems: 'flex-start'}}>{summary}</Alert>
    </Stack>
);

export default NodeEditorLayout;
